// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"648a03ff","359":"edf5bc1c","386":"1e82b212","453":"94a9fc84","904":"0f232ec8","998":"81b06941"}[chunkId] + ".chunk.js";
};